import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ScraiiAiComponent } from "./page/scraii-ai/scraii-ai.component";
import { DirectComponent } from "./page/direct/direct.component";
import { WorkflowManagementComponent } from "./page/workflow-management/workflow-management.component";
import { WorkflowDesignerComponent } from "./components/workflow-designer/workflow-designer.component";
import { EmailTemplateDesignerComponent } from "./page/email-template-designer/email-template-designer.component";
import { EmailExtractsComponent } from "./page/email-extracts/email-extracts.component";
import { TaskDetailPageComponent } from "./page/task-detail/task-detail.component";

const routes: Routes = [
  {
    path: "",
    component: DirectComponent,
  },
  {
    path: ":module/task-detail/:taskId",
    component: TaskDetailPageComponent,
  },
  {
    path: ":module",
    component: DirectComponent,
  },
  {
    path: ":module/email-designer",
    component: EmailTemplateDesignerComponent,
  },
  {
    path: ":module/direct/Designer",
    component: WorkflowDesignerComponent,
  },
  // {
  //   path: ":module/email-extracts",
  //   component: EmailExtractsComponent,
  // },
  {
    path: ":module/page",
    pathMatch: "full",
    component: DirectComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DirectRoutingModule {}
